import wn7State1 from 'assets/images/missions/wn_7_1.webp';
import wn7State2 from 'assets/images/missions/wn_7_2.webp';
import wn7State3 from 'assets/images/missions/wn_7_3.webp';
import wn7State4 from 'assets/images/missions/wn_7_4.webp';
import wn7State5 from 'assets/images/missions/wn_7_5.webp';
import type { IStreakMissionProps } from '../helpers/streakMission';
import { MissionId } from '../types';

type StreakMissionsRegistry = Record<string, IStreakMissionProps>;

export const STREAK_MISSIONS: StreakMissionsRegistry = {
  [MissionId.WN_7]: {
    images: [wn7State5, wn7State1, wn7State2, wn7State3, wn7State4, wn7State5],
    maxStreak: 5,
  },
};
